import { blueGrey, blue, green, orange, red } from '@mui/material/colors';

import { createTheme } from '@mui/material/styles';
import shadows, { Shadows } from '@mui/material/styles/shadows';

const funGreenDark = '#005d2f';
const FunGreenLight = '#007d40';

// const infoBlue = '#1d86d9';
// const infoBlueLight = '#deecf9';
// const infoBlueDark = '#003c6d';

const primary =  '#007d40';
const secondary = blueGrey[300];
const	white = '#fff';

export default createTheme({
  // shadows: shadows.map( () => 'none' ) as Shadows,
	palette: {
		primary: {
			main: primary,
			contrastText: white,
		},
    // info: {
    //   main:  infoBlue,
    //   light: infoBlueLight,
    //   dark: infoBlueDark,
    // },
		secondary: {
			main: secondary,
			contrastText: white,
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
	},
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": {
            paddingBottom: '16px',
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {

        // Remove asterik for required fields
        asterisk: {
          display: 'none',
        },
      }
    },
  },
	typography: {
		fontFamily: [
			'Roboto',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	},
	spacing: 8,
  // For an application which its single purpose is only authentication
  // it sort of make sense to adjust all breakpoints in a lower range.
  breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 700,
			lg: 1200,
			xl: 1400,
		},
	},
});
